import { useEffect } from "react";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryCards from "@/pages/home/components/CategoryCards";
import LatestNews from "@/pages/home/components/LatestNews";
import FeaturedResources from "@/pages/home/components/FeaturedResources";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  useEffect(() => {
    document.title = "想要XX - 品牌介绍与资源查询平台";
  }, []);

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryCards />
      <LatestNews />
      <FeaturedResources />
      <SiteIntro />
    </div>
  );
}